var myModal = $('.modal')
myModal.each(function(){
	var id = document.getElementById($(this).attr('id'));
	id.addEventListener('shown.bs.modal', function () {
		window.dispatchEvent(new Event('resize'));
	})
})